import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  X,
  Home,
  MapPin,
  Truck,
  Users,
  BarChart3,
  Settings,
  Bell,
  Search,
  Map,
  Activity,
  Shield,
  Clock,
  AlertTriangle,
  TrendingUp,
  Navigation,
  ChevronDown,
  ChevronRight,
  Route,
  FileText,
  LogOut,
  Building2,
  Warehouse,
  UserCheck,
  Package,
  User,
  Grid3X3,
  Loader2,
  FileType,
  RefreshCw,
  CheckCircle,
  TableProperties,
  ClipboardList,
  Store,
  Wrench,
} from "lucide-react";
import Geofences from "./Geofences";
import Transportistas from "./Transportistas";
import Viajes from "./Viajes";
import SeguimientoFlota from "./SeguimientoFlota";
import toast from "react-hot-toast";
import RolesPermisos from "./RolesPermisos";
import Empresas from "./Empresas";
import Establecimientos from "./Establecimientos";
import ListarVehiculos from "./ListarVehiculos";
import RegistrarVehiculo from "./RegistrarVehiculo";
import TiposDocumento from "./TiposDocumento";
import Documentos from "./Documentos";
import AlertasVencimiento from "./AlertasVencimiento";
import ListarConductores from "./ListarConductores";
import RolesGestion from "./RolesGestion";
import MenusGestion from "./MenusGestion";
import DashboardCharts from "./DashboardCharts";
import Invitaciones from "./Invitaciones";
import GestionUsuarios from "./GestionUsuarios";
import { UserPlus } from "lucide-react"; // Ya está importado
import ModulosEmpresaGestion from "./ModulosEmpresaGestion";
import IframeModule from "./IframeModule";
//import FacturacionLayout from "./facturacion/FacturacionLayout";
import GestionReglas from "./notificaciones/GestionReglas";
import ConfigNotificacionesViajes from "./viajes/ConfigNotificacionesViajes";

// Componentes de Mantenimiento cargados nativamente
import GestionFlota from "./maintenance/GestionFlota";
import GestionOrdenes from "./maintenance/GestionOrdenes";
import PlanesMaestros from "./maintenance/PlanesMaestros";
import ReportesMantenimiento from "./maintenance/ReportesMantenimiento";
import GestionPlanes from "./maintenance/GestionPlanes";
import GestionTalleres from "./maintenance/GestionTalleres";
import ProveedoresLayout from "./maintenance/ProveedoresLayout";
const Dashboard = () => {
  const navigate = useNavigate(); // ✅ AGREGAR ESTA LÍNEA AQUÍ
  const {
    user,
    logout,
    getMenuStructure,
    hasMenuPermission,
    loading: authLoading,
  } = useAuth();
  const [userPermissions, setUserPermissions] = useState({
    canCreateRoles: false,
    canCreateMenus: false,
    canCreateEmpresas: false,
    isSuperAdmin: false,
  });

  useEffect(() => {
    // Determinar permisos del usuario
    const isSuperAdmin = !user?.empresa_id; // NULL = Super Admin
    setUserPermissions({
      isSuperAdmin,
      canCreateRoles: isSuperAdmin,
      canCreateMenus: isSuperAdmin,
      canCreateEmpresas: isSuperAdmin,
    });
  }, [user]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeSection, setActiveSection] = useState("dashboard");
  const [expandedMenus, setExpandedMenus] = useState([]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [menuStructure, setMenuStructure] = useState([]);
  const [loadingMenus, setLoadingMenus] = useState(true);

  // ⚡️ OPTIMIZACIÓN: Sistema Keep-Alive para persistencia de secciones
  const [visitedSections, setVisitedSections] = useState(new Set([activeSection]));

  useEffect(() => {
    setVisitedSections((prev) => new Set([...prev, activeSection]));
  }, [activeSection]);

  // Mapeo de iconos basado en el slug o nombre del menú
  const iconMap = {
    // Nivel 1 — módulos
    principal: Home,
    operaciones: Activity,
    gestion: Settings,
    reportes: BarChart3,
    sistema: Shield,
    mantenimiento: Settings,
    documentos: FileText, // ← NUEVO módulo Documentos y Vigencia
    // Mantenimiento submenús
    "mantenimiento-vehiculos": Truck,
    "mantenimiento/flota": Truck,
    "mantenimiento-ordenes": ClipboardList,
    "mantenimiento-planes": TableProperties,
    "mantenimiento/planes-gestion": Settings,
    "mantenimiento-talleres": Building2,
    "mantenimiento/proveedores": Store,
    proveedores: Store,
    "reportes-mantenimiento": BarChart3,
    preventivo: CheckCircle,

    // Documentos y Vigencia submenús  ← NUEVOS
    "doc-tipos": FileType,
    "doc-lista": FileText,
    "doc-alertas": Bell,
    "reportes-documentos": BarChart3,

    // Operaciones submenús
    dashboard: Home,
    mapa: Map,
    "mapa-tiempo-real": Map,
    geocercas: MapPin,
    rutas: Route,
    viajes: Package,
    seguimiento_flota: Navigation,
    alertas: Bell,
    "reportes-viajes": TrendingUp, // ← ahora dentro de Operaciones

    // Gestión submenús
    flota: Truck,
    choferes: Users,
    empresas: Building2,
    establecimientos: Warehouse,
    "almaceneras-navieras": Warehouse,
    "gestion-roles-empresa": Shield,

    // Reportes (legado — desactivado pero por si acaso)
    "reportes-historicos": BarChart3,
    "dashboard-charts": TrendingUp,
    eventos: FileText,

    // Sistema submenús
    configuracion: Settings,
    usuarios: Users,
    roles: UserCheck,
    permisos: Shield,
    invitaciones: UserPlus,
    "gestion-roles-emrpresa": Shield,
    "usuarios-invitaciones": UserPlus,

    // Módulos de Empresa
    "modulos-empresa": Package,
    "gestion-modulos-empresa": Package,

    // Facturación
    facturacion: FileText,
    "facturacion-gre": FileText,
    "facturacion-facturas": FileText,
    "facturacion-boletas": FileText,
    "facturacion-nc": FileText,
    "facturacion-anulaciones": FileText,
  };

  // Detectar dispositivo móvil
  //esto es un comentario de prueba
  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth < 768;
      setIsMobile(isMobileDevice);
      if (isMobileDevice) {
        setSidebarCollapsed(true);
      }
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const loadMenus = async () => {
      setLoadingMenus(true);
      try {
        const structure = getMenuStructure();
        console.log("Menu structure loaded:", structure);
        setMenuStructure(structure);
        // Expandir dinámicamente el grupo que contiene la sección activa
        const activeParent = structure.find(menu => 
          menu.children && menu.children.some(child => 
            child.slug === activeSection || 
            child.route === activeSection ||
            (child.children && child.children.some(grandchild => grandchild.slug === activeSection || grandchild.route === activeSection))
          )
        );
        if (activeParent) {
          setExpandedMenus([activeParent.id]);
        } else {
          setExpandedMenus([]);
        }
      } catch (error) {
        console.error("Error loading menus:", error);
        toast.error("Error al cargar los menús");
      } finally {
        setLoadingMenus(false);
      }
    };
    if (!authLoading) {
      loadMenus();
    }
  }, [getMenuStructure, authLoading]);

  // Expandir el menú correcto cuando cambie la sección activa de forma dinámica
  useEffect(() => {
    if (menuStructure.length > 0 && activeSection) {
      const activeParent = menuStructure.find(menu => 
        menu.children && menu.children.some(child => 
          child.slug === activeSection || 
          child.route === activeSection ||
          (child.children && child.children.some(grandchild => grandchild.slug === activeSection || grandchild.route === activeSection))
        )
      );
      if (activeParent) {
        setExpandedMenus(prev => prev.includes(activeParent.id) ? prev : [...prev, activeParent.id]);
      }
    }
  }, [activeSection, menuStructure]);

  const toggleMenu = (menuId) => {
    setExpandedMenus((prev) => {
      if (prev.includes(menuId)) {
        return prev.filter((id) => id !== menuId);
      } else {
        return [...prev, menuId];
      }
    });
  };

  // Slugs que pertenecen al módulo de mantenimiento (iframe)
  const MANTENIMIENTO_SLUGS = [
    "mantenimiento-vehiculos",
    "mantenimiento-ordenes",
    "mantenimiento-planes",
    "reportes-mantenimiento",
    "mantenimiento/flota",
    "mantenimiento/planes-gestion",
    "mantenimiento-talleres",
    "mantenimiento/proveedores",
  ];

  const handleMenuClick = (menu) => {
    if (menu.children && menu.children.length > 0) {
      toggleMenu(menu.id);
    } else if (menu.route || menu.slug) {
      // Todos los menús usan setActiveSection — incluido mantenimiento
      setActiveSection(menu.slug);
      if (isMobile) setShowMobileSidebar(false);
    }
  };
  const confirmLogout = () => {
    logout();
    setTimeout(() => {
      window.location.href = "/login";
    }, 100);
  };

  const getIcon = (menu) => {
    const IconComponent = iconMap[menu.slug] || iconMap[menu.icon] || Grid3X3;
    return IconComponent;
  };

  const getUserRoleIcon = () => {
    const roleIcons = {
      admin: UserCheck,
      transportista: Truck,
      operador_logistico: Building2,
      cliente: User,
    };
    const userRole = user?.roles?.[0]?.name;
    return roleIcons[userRole] || User;
  };

  const getUserRoleColor = () => {
    const roleColors = {
      admin: "text-purple-600",
      transportista: "text-blue-600",
      operador_logistico: "text-green-600",
      cliente: "text-orange-600",
    };
    const userRole = user?.roles?.[0]?.name;
    return roleColors[userRole] || "text-gray-600";
  };
  const statsCards = [
    {
      title: "Vehículos Activos",
      value: "48",
      change: "+12%",
      icon: Truck,
      color: "bg-gradient-to-br from-blue-500 to-blue-600",
    },
    {
      title: "Geocercas Configuradas",
      value: "23",
      change: "+3",
      icon: MapPin,
      color: "bg-gradient-to-br from-green-500 to-green-600",
    },
    {
      title: "Alertas Hoy",
      value: "7",
      change: "-2",
      icon: AlertTriangle,
      color: "bg-gradient-to-br from-yellow-500 to-orange-500",
    },
    {
      title: "Tiempo Promedio en Ruta",
      value: "4.2h",
      change: "+5%",
      icon: Clock,
      color: "bg-gradient-to-br from-purple-500 to-purple-600",
    },
  ];

  const systemModules = [
    {
      name: "Mapa en Tiempo Real",
      icon: Map,
      color: "text-blue-600",
      description: "Monitoreo GPS",
    },
    {
      name: "Geocercas",
      icon: MapPin,
      color: "text-green-600",
      description: "Zonas virtuales",
    },
    {
      name: "Gestión de Flota",
      icon: Truck,
      color: "text-orange-600",
      description: "Vehículos",
    },
    {
      name: "Reportes",
      icon: BarChart3,
      color: "text-purple-600",
      description: "Análisis",
    },
    {
      name: "Alertas",
      icon: Bell,
      color: "text-red-600",
      description: "Notificaciones",
    },
    {
      name: "Configuración",
      icon: Settings,
      color: "text-gray-600",
      description: "Sistema",
    },
  ];

  const recentActivity = [
    {
      id: 1,
      vehicle: "Truck-001",
      action: "Entrada a Zona Centro",
      time: "10:30 AM",
      status: "success",
    },
    {
      id: 2,
      vehicle: "Truck-045",
      action: "Alerta: Fuera de ruta",
      time: "10:15 AM",
      status: "warning",
    },
    {
      id: 3,
      vehicle: "Truck-023",
      action: "Salida de Zona Industrial",
      time: "09:45 AM",
      status: "info",
    },
    {
      id: 4,
      vehicle: "Truck-067",
      action: "Detención prolongada",
      time: "09:30 AM",
      status: "warning",
    },
    {
      id: 5,
      vehicle: "Truck-012",
      action: "Inicio de ruta",
      time: "09:00 AM",
      status: "success",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "success":
        return "text-green-600";
      case "warning":
        return "text-yellow-600";
      case "info":
        return "text-blue-600";
      default:
        return "text-gray-600";
    }
  };
  // Función para renderizar menú recursivamente para evitar re-montaje de componentes React (mantiene el scroll)
  const renderMenu = (menu, level = 1) => {
    const hasChildren = menu.children && menu.children.length > 0;
    const isExpanded = expandedMenus.includes(menu.id);
    const isActive = activeSection === menu.slug;
    const Icon = getIcon(menu);

    if (menu.permissions && !menu.permissions.can_view) return null;

    return (
      <div key={menu.id}>
        {level === 1 && (!sidebarCollapsed || isMobile) && (
          <div className="flex items-center justify-between px-2 py-1 mb-1">
            <p className="font-medium text-gray-500 text-xs uppercase tracking-wider">
              {menu.name}
            </p>
            {hasChildren && (
              <button
                onClick={() => toggleMenu(menu.id)}
                className="p-0.5 rounded hover:bg-gray-100"
              >
                {isExpanded ? (
                  <ChevronDown className="h-3 w-3 text-gray-400" />
                ) : (
                  <ChevronRight className="h-3 w-3 text-gray-400" />
                )}
              </button>
            )}
          </div>
        )}

        {(level > 1 || !hasChildren || isExpanded) && (
          <div className={`${level > 1 ? "ml-2" : ""} space-y-0.5`}>
            {level > 1 && (
              <button
                onClick={() => handleMenuClick(menu)}
                className={`flex items-center w-full px-2 py-2 rounded-lg text-sm transition-all ${isActive
                  ? "bg-blue-50 text-blue-600 shadow-sm"
                  : "text-gray-700 hover:bg-gray-50"
                  } ${sidebarCollapsed && !isMobile ? "justify-center" : ""}`}
                title={sidebarCollapsed && !isMobile ? menu.name : ""}
              >
                <Icon
                  className={`h-4 w-4 ${sidebarCollapsed && !isMobile ? "" : "mr-2"
                    } flex-shrink-0`}
                />
                {(!sidebarCollapsed || isMobile) && (
                  <span className="truncate">{menu.name}</span>
                )}
                {hasChildren && (!sidebarCollapsed || isMobile) && (
                  <ChevronRight
                    className={`h-3 w-3 ml-auto transition-transform ${isExpanded ? "rotate-90" : ""
                      }`}
                  />
                )}
              </button>
            )}
            {hasChildren &&
              isExpanded &&
              menu.children.map((child) => renderMenu(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  // Renderizar contenido según la sección activa
  const renderContent = (sectionSlug) => {
    const targetSection = sectionSlug || activeSection;
    if (targetSection === "geocercas") return <Geofences />;
    if (targetSection === "viajes") return <Viajes activeSection={activeSection} />;
    if (targetSection === "transportistas") return <Transportistas />;
    if (targetSection === "seguimiento_flota")
      return (
        <SeguimientoFlota onVolverAtras={() => setActiveSection("dashboard")} />
      );
    if (targetSection === "flota-listar") return <ListarVehiculos />;
    if (targetSection === "flota-crear") return <RegistrarVehiculo />;

    // ── Módulo de Mantenimiento (Nativo) ────────────────────────────────────
    if (targetSection === "mantenimiento-vehiculos" || targetSection === "mantenimiento/flota")
      return <GestionFlota />;
    if (targetSection === "mantenimiento-ordenes")
      return <GestionOrdenes />;
    if (targetSection === "mantenimiento-planes")
      return <PlanesMaestros />;
    if (targetSection === "reportes-mantenimiento")
      return <ReportesMantenimiento />;
    if (targetSection === "mantenimiento-planes-gestion")
      return <GestionPlanes />;
    if (targetSection === "mantenimiento-talleres")
      return <GestionTalleres />;
    if (targetSection === "mantenimiento/proveedores")
      return <ProveedoresLayout />;
    // ──────────────────────────────────────────────────────────────────────
    if (targetSection === "config-roles" || targetSection === "roles")
      return <RolesPermisos />;
    if (targetSection === "choferes") return <ListarConductores />;
    if (targetSection === "gestion-roles-empresa") return <RolesGestion />;
    if (targetSection === "gestion-modulos-empresa")
      return <ModulosEmpresaGestion />;
    if (targetSection === "empresas") return <Empresas />;
    if (targetSection === "establecimientos") return <Establecimientos />;
    if (targetSection === "gestion-roles") return <RolesGestion />;
    if (targetSection === "gestion-menus") return <MenusGestion />;
    if (targetSection === "gestion-reglas") return <GestionReglas />;
    if (targetSection === "config-notificaciones-viajes") return <ConfigNotificacionesViajes />;
    if (targetSection === "invitaciones") return <Invitaciones />;
    if (targetSection === "usuarios" || targetSection === "config-usuarios")
      return <GestionUsuarios />;
    if (targetSection === "doc-tipos") return <TiposDocumento />;
    if (targetSection === "doc-lista") return <Documentos />;
    if (targetSection === "doc-alertas") return <AlertasVencimiento />;

    // ── Módulo de Facturación ────────────────────────────────────────────────
    // if (targetSection?.startsWith("facturacion"))
    //   return <FacturacionLayout activeSlug={targetSection} />;
    // ────────────────────────────────────────────────────────────────────────

    // ── Reportes dentro de cada módulo ──────────────────────────────
    // Reportes de Viajes (slug movido a dentro de Operaciones)
    if (targetSection === "reportes-viajes")
      return <DashboardCharts user={user} />;

    // Reportes de Mantenimiento ← NUEVO
    if (targetSection === "reportes-mantenimiento")
      return (
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <BarChart3 className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Reportes de Mantenimiento
            </h3>
            <p className="text-gray-500">Componente en desarrollo.</p>
          </div>
        </div>
      );

    // Reportes de Documentos ← NUEVO
    if (targetSection === "reportes-documentos")
      return (
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <BarChart3 className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Reportes de Documentos
            </h3>
            <p className="text-gray-500">Componente en desarrollo.</p>
          </div>
        </div>
      );
    // ────────────────────────────────────────────────────────────────

    if (targetSection === "dashboard") {
      return (
        <div className="space-y-3 md:space-y-4">
          <div className="bg-white/95 backdrop-blur-sm p-3 md:p-4 rounded-xl shadow-sm border border-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1">
                <h1 className="text-lg md:text-xl font-bold text-gray-800">
                  Sistema de Geocercas y Tracking GPS
                </h1>
                <p className="text-xs text-gray-500 mt-0.5">
                  Monitoreo en tiempo real de flota vehicular
                </p>
              </div>
              <div className="flex items-center justify-between sm:justify-end gap-3">
                <div className="flex items-center sm:text-right">
                  <div className="sm:hidden mr-2">
                    <div className={`p-1.5 rounded-full bg-gray-100`}>
                      <UserRoleIcon
                        className={`h-4 w-4 ${getUserRoleColor()}`}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="font-medium text-gray-700 text-sm">
                      {user?.name || "Usuario"}
                    </p>
                    <p className="text-xs text-gray-500 capitalize">
                      {user?.roles?.[0]?.name || "Sin rol"}
                    </p>
                  </div>
                </div>
                <button
                  onClick={confirmLogout}
                  className="flex items-center text-xs text-red-600 hover:text-red-700 transition-colors p-2 hover:bg-red-50 rounded-lg"
                >
                  <LogOut className="h-3 w-3 mr-1" />
                  <span className="hidden sm:inline">Cerrar Sesión</span>
                </button>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3">
            {statsCards.map((stat, i) => (
              <div
                key={i}
                className="bg-white/95 p-3 md:p-4 rounded-xl shadow-sm border border-gray-50 hover:shadow-md transition-shadow"
              >
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2">
                  <div className="flex-1">
                    <p className="text-xs text-gray-500 font-medium mb-1">
                      {stat.title}
                    </p>
                    <p className="text-xl md:text-2xl font-bold text-gray-800">
                      {stat.value}
                    </p>
                    <p
                      className={`text-xs font-medium mt-1 ${stat.change.startsWith("+")
                        ? "text-green-600"
                        : "text-red-600"
                        }`}
                    >
                      {stat.change}
                    </p>
                  </div>
                  <div
                    className={`${stat.color} p-2 md:p-2.5 rounded-lg shadow-sm self-end sm:self-start`}
                  >
                    <stat.icon className="h-4 w-4 text-white" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
            <div className="bg-white/95 p-3 md:p-4 rounded-xl shadow-sm border border-gray-50">
              <div className="flex items-center mb-3">
                <Grid3X3 className="h-4 w-4 text-blue-600 mr-2" />
                <h3 className="font-semibold text-gray-700 text-sm">
                  Módulos del Sistema
                </h3>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-2">
                {systemModules.map((module, i) => (
                  <div
                    key={i}
                    className="p-2 md:p-3 rounded-lg border border-gray-100 hover:border-gray-200 hover:bg-gray-50/50 transition-all cursor-pointer"
                    onClick={() => {
                      if (module.name === "Reportes")
                        setActiveSection("reportes-viajes");
                    }}
                  >
                    <div className="flex items-center mb-1">
                      <module.icon
                        className={`h-4 w-4 ${module.color} mr-2 flex-shrink-0`}
                      />
                      <span className="text-xs font-medium text-gray-700 truncate">
                        {module.name}
                      </span>
                    </div>
                    <p className="text-xs text-gray-500">
                      {module.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white/95 p-3 md:p-4 rounded-xl shadow-sm border border-gray-50">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center">
                  <Activity className="h-4 w-4 text-green-600 mr-2" />
                  <h3 className="font-semibold text-gray-700 text-sm">
                    Actividad Reciente
                  </h3>
                </div>
                <span className="text-xs text-gray-400">Últimas 24h</span>
              </div>
              <div className="space-y-2 max-h-48 md:max-h-64 overflow-y-auto">
                {recentActivity.map((act) => (
                  <div
                    key={act.id}
                    className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50/50 transition-colors"
                  >
                    <div className="flex-1 min-w-0 pr-2">
                      <p className="text-xs font-medium text-gray-700 truncate">
                        {act.vehicle}
                      </p>
                      <p
                        className={`text-xs ${getStatusColor(act.status)} truncate`}
                      >
                        {act.action}
                      </p>
                    </div>
                    <span className="text-xs text-gray-400 whitespace-nowrap">
                      {act.time}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Grid3X3 className="h-12 w-12 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Sección en desarrollo
          </h3>
          <p className="text-gray-500">
            Esta funcionalidad estará disponible próximamente.
          </p>
        </div>
      </div>
    );
  };

  const UserRoleIcon = getUserRoleIcon();

  if (authLoading || loadingMenus) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600 mx-auto" />
          <p className="mt-4 text-gray-600">Cargando dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {isMobile && showMobileSidebar && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setShowMobileSidebar(false)}
        />
      )}

      <div
        className={`
        ${isMobile
            ? `fixed left-0 top-0 h-full z-50 transform transition-transform duration-300 ${showMobileSidebar ? "translate-x-0" : "-translate-x-full"
            } w-64`
            : `${sidebarCollapsed ? "w-16" : "w-56"
            } transition-all duration-300`
          } 
        bg-white shadow-lg flex flex-col border-r border-gray-200
      `}
      >
          <div className="p-3 border-b border-gray-100">
    <div className="flex items-center justify-between">

      {/* Logo circular + Nombre empresa */}
      {(!sidebarCollapsed || isMobile) && (
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <div className="flex-shrink-0 h-8 w-8 rounded-full overflow-hidden bg-gray-100 flex items-center justify-center">
            {user?.empresa?.logo_url ? (
              <img
                src={user.empresa.logo_url}
                alt={user.empresa?.nombre || "Logo"}
                className="h-full w-full object-cover"
              />
            ) : (
              <span className="font-bold text-sm text-blue-600">V</span>
            )}
          </div>
          <span className="font-bold text-sm text-blue-600 leading-tight">
            {user?.empresa?.nombre || process.env.REACT_APP_BRAND_NAME || "Synkro Fleet"}
          </span>
        </div>
      )}

      {/* Colapsado: logo solo */}
      {sidebarCollapsed && !isMobile && (
        <div className="flex-1 flex justify-center">
          {user?.empresa?.logo_url ? (
            <img
              src={user.empresa.logo_url}
              alt="Logo"
              className="h-7 w-7 object-contain"
            />
          ) : (
            <span className="font-bold text-sm text-blue-600">V</span>
          )}
        </div>
      )}

      <button
        onClick={() => {
          if (isMobile) setShowMobileSidebar(false);
          else setSidebarCollapsed(!sidebarCollapsed);
        }}
        className="p-1 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0"
      >
        {isMobile ? (
          <X className="h-4 w-4" />
        ) : sidebarCollapsed ? (
          <ChevronRight className="h-4 w-4" />
        ) : (
          <Menu className="h-4 w-4" />
        )}
      </button>
    </div>

    {/* Info usuario expandido */}
    {(!sidebarCollapsed || isMobile) && user && (
      <div className="mt-2 p-2 bg-gray-50 rounded-lg">
        <div className="flex items-center gap-2">
          <div className="p-1.5 rounded-full bg-white shadow-sm flex-shrink-0">
            <UserRoleIcon className={`h-3 w-3 ${getUserRoleColor()}`} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-gray-800 truncate leading-tight">
              {user.name}
            </p>
            <p className="text-xs text-gray-500 truncate leading-tight">
              {user.roles?.[0]?.name || "Sin rol"}
            </p>
          </div>
        </div>
      </div>
    )}

    {/* Info usuario colapsado */}
    {sidebarCollapsed && !isMobile && user && (
      <div className="mt-2 flex justify-center">
        <div
          className="p-1.5 rounded-full bg-gray-50 shadow-sm"
          title={[user.name, user.roles?.[0]?.name, user?.empresa?.nombre]
            .filter(Boolean)
            .join(" · ")}
        >
          <UserRoleIcon className={`h-3 w-3 ${getUserRoleColor()}`} />
        </div>
      </div>
    )}
  </div>

        <nav className="flex-1 overflow-y-auto p-2 space-y-1">
          {menuStructure.length > 0 ? (
            menuStructure.map((menu) => renderMenu(menu, 1))
          ) : (
            <div className="text-center p-4">
              <p className="text-xs text-gray-500">No hay menús disponibles</p>
              <button
                onClick={() => window.location.reload()}
                className="mt-2 p-2 text-xs text-blue-600 hover:bg-blue-50 rounded-lg flex items-center mx-auto"
              >
                <RefreshCw className="h-3 w-3 mr-1" />
                Recargar
              </button>
            </div>
          )}
        </nav>

        {(!sidebarCollapsed || isMobile) && (
          <div className="p-2 border-t border-gray-100">
            <button
              onClick={confirmLogout}
              className="flex items-center w-full px-2 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            >
              <LogOut className="h-4 w-4 mr-2 flex-shrink-0" />
              Cerrar Sesión
            </button>
          </div>
        )}
      </div>

      <main className="flex-1 flex flex-col overflow-hidden">
        {isMobile && (
          <div className="bg-white border-b border-gray-200 p-3 flex items-center justify-between md:hidden">
            <button
              onClick={() => setShowMobileSidebar(true)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Menu className="h-5 w-5" />
            </button>
            <span className="font-bold text-blue-600">{process.env.REACT_APP_BRAND_NAME || "Synkro Fleet"}</span>
            <div className="w-9"></div>
          </div>
        )}

        <div className="flex-1 p-2 md:p-3 overflow-y-auto relative">
          {[...visitedSections].map((slug) => (
            <div
              key={slug}
              className={`h-full ${slug === activeSection ? "block" : "hidden"}`}
            >
              {renderContent(slug)}
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;

